const Word = ({ size }: { size: number }) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.833 4H10.167C9.85757 4.00026 9.5609 4.1233 9.3421 4.3421C9.1233 4.5609 9.00026 4.85757 9 5.167V10L19.5 11.625L30 10V5.167C29.9997 4.85757 29.8767 4.5609 29.6579 4.3421C29.4391 4.1233 29.1424 4.00026 28.833 4Z"
      fill="#41A5EE"
    />
    <path d="M30 10H9V16L19.5 18L30 16V10Z" fill="#2B7CD3" />
    <path d="M30 16H9V22L19.5 24L30 22V16Z" fill="#185ABD" />
    <path
      d="M30 22H9V26.833C9.00026 27.1424 9.1233 27.4391 9.3421 27.6579C9.5609 27.8767 9.85757 27.9997 10.167 28H28.833C29.1424 27.9997 29.4391 27.8767 29.6579 27.6579C29.8767 27.4391 29.9997 27.1424 30 26.833V22Z"
      fill="#103F91"
    />
    <path
      opacity="0.5"
      d="M17 11V22.83C16.9979 23.1397 16.874 23.436 16.655 23.655C16.436 23.874 16.1397 23.9979 15.83 24H9V10H16C16.2652 10 16.5196 10.1054 16.7071 10.2929C16.8946 10.4804 17 10.7348 17 11Z"
      fill="#000000"
    />
    <path
      d="M14.833 9H3.167C2.52248 9 2 9.52248 2 10.167V21.833C2 22.4775 2.52248 23 3.167 23H14.833C15.4775 23 16 22.4775 16 21.833V10.167C16 9.52248 15.4775 9 14.833 9Z"
      fill="#185ABD"
    />
    <path
      d="M12.4559 20.375H10.8809L9.04395 14.338L7.11895 20.375H5.54395L3.79395 11.625H5.36895L6.59395 17.75L8.43095 11.8H9.74395L11.4939 17.75L12.7189 11.625H14.2059L12.4559 20.375Z"
      fill="#FFFFFF"
    />
  </svg>
);

export default Word;
